import { FC } from "react";
import clsx from "clsx";
import cx from "apps/website/utils/misc/cx";
import { Theme } from "apps/website/maps/Theme.map";

import { CTAButton, TCTAButtonProps } from "../../base/CTAButton/CTAButton";
import Section from "../../layout/Section/Section";
import Column from "../../layout/Column/Column";
import Grid from "../../layout/Grid/Grid";

import { THeaderType, HeaderRenderer } from "./Header/HeaderRenderer";
import { TFooterType, FooterRenderer } from "./Footer/FooterRenderer";

export interface IStickyCTAProps {
  button: TCTAButtonProps,
  header?: THeaderType
  footer?: TFooterType
  secondaryButton?: TCTAButtonProps
  position?: "sticky" | "fixed"
  shadow?: boolean
  theme?: Theme
}

export const StickyCTA: FC<IStickyCTAProps> = ({ footer, header, button, secondaryButton, position = "sticky", shadow = false, theme = "light" }) => (
  <div
    data-component={StickyCTA.name}
    className={cx(
      "bottom-0",
      position === "fixed"
        ? "fixed left-0 right-0 z-20"
        : "sticky z-10",
      "transition-all duration-300 ease-in-out",
      shadow ? "footer-shadow" : "",
    )}
  >
    <div className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
      <Section
        theme={theme}
        size={"md-lg"}
      >
        <Grid gap="none">
          <Column align="center" className="px-6">
            { header && <HeaderRenderer header={header} /> }

            <div
              className={clsx(
                secondaryButton
                  ? "flex items-center justify-center gap-x-4 w-full max-w-xl mx-auto"
                  : "w-full max-w-[342px] md:max-w-[600px]",
              )}
            >
              { secondaryButton && (
                <div className="w-auto md:flex-1">
                  <CTAButton {...secondaryButton} />
                </div>
              ) }
              <div
                className={clsx(
                  secondaryButton
                    ? "flex-1"
                    : "w-full",
                )}
              >
                <CTAButton {...button} />
              </div>
            </div>

            { footer && <FooterRenderer footer={footer} /> }
          </Column>
        </Grid>
      </Section>
    </div>
  </div>
);
